import { useTheme } from 'foundations-theming/utils';
import { useCallback, useEffect, useRef, useState } from 'react';
import DocumentPreviewPopover from './DocumentPreviewPopover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import contentOutputs from '../../editorCapabilities/ContentOutputTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentPreviewTable = ({
  documentId,
  previewImage,
  previewTitle,
  setPreviewTitle,
  description,
  setDescription,
  documentName,
  showEditPreview,
  setShowEditPreview,
  editable,
  outputType,
  tokenTag,
  updatePreview
}) => {
  const trellisTheme = useTheme();
  const ref = useRef(null);
  const previewRef = useRef(null);
  const [imageFailed, setImageFailed] = useState(false);
  const handleOutsideClick = useCallback(event => {
    var _ref$current, _previewRef$current;
    if (!((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target)) && !((_previewRef$current = previewRef.current) !== null && _previewRef$current !== void 0 && _previewRef$current.contains(event.target))) {
      setShowEditPreview(false);
    }
  }, [setShowEditPreview]);
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [handleOutsideClick]);
  const documentLink = outputType !== contentOutputs.EDITABLE ? /*#__PURE__*/_jsx("span", {
    "data-test-id": "ProseMirror__documents",
    children: /*#__PURE__*/_jsx("a", {
      href: tokenTag,
      target: "_blank",
      rel: "noreferrer",
      children: tokenTag
    })
  }) : /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "draftPlugins.documents.mergeTag.tooltip"
    }),
    placement: "top",
    children: /*#__PURE__*/_jsx("span", {
      style: {
        height: '20px',
        width: 'auto',
        padding: `${trellisTheme.space['100']} ${trellisTheme.space['200']}`,
        backgroundColor: trellisTheme.color['fill-info-subtle'],
        borderRadius: trellisTheme.borderRadius['100'],
        color: trellisTheme.color['fill-info-default'],
        border: `${trellisTheme.borderWidth['100']} solid transparent`
      },
      children: documentName
    })
  });
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs("figure", {
      style: {
        marginBlockStart: trellisTheme.space['600'],
        position: 'relative',
        display: 'inline-block',
        width: '400px'
      },
      ref: ref,
      children: [/*#__PURE__*/_jsx("table", {
        style: Object.assign({
          cursor: 'pointer',
          width: '100%',
          border: 'solid 1px #00a4bd',
          padding: '8px',
          borderRadius: '2px',
          marginBottom: '0'
        }, showEditPreview && {
          boxShadow: '0px 0px 14px rgba(14, 131, 255, 0.3)',
          transition: 'box-shadow 150ms ease'
        }),
        "data-hs-document-link-preview-id": documentId,
        onClick: () => {
          if (!editable || outputType !== contentOutputs.EDITABLE) return;
          setShowEditPreview(true);
        },
        children: /*#__PURE__*/_jsx("tbody", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("img", {
                src: previewImage,
                alt: previewTitle,
                className: "document-link-preview-image",
                onError: () => {
                  setImageFailed(true);
                },
                style: Object.assign({
                  display: 'block',
                  margin: `${trellisTheme.space['0']} auto`,
                  maxWidth: '150px',
                  maxHeight: '150px'
                }, imageFailed ? {
                  width: 0,
                  height: 0
                } : {})
              })
            }), /*#__PURE__*/_jsxs("td", {
              style: {
                paddingInlineStart: trellisTheme.space['200'],
                textAlign: 'left'
              },
              children: [/*#__PURE__*/_jsx("h2", {
                className: "document-link-preview-name",
                style: {
                  color: '#33475b',
                  marginTop: '0',
                  marginBottom: '8px'
                },
                children: previewTitle
              }), /*#__PURE__*/_jsx("p", {
                className: "document-link-preview-description",
                style: {
                  color: '#33475b',
                  marginBottom: '8px'
                },
                children: description
              }), documentLink]
            })]
          })
        })
      }), showEditPreview && /*#__PURE__*/_jsx(DocumentPreviewPopover, {
        previewTitle: previewTitle,
        description: description,
        setPreviewTitle: setPreviewTitle,
        setDescription: setDescription,
        ref: previewRef,
        updatePreview: updatePreview
      })]
    })
  );
};
export default DocumentPreviewTable;